module.exports = __webpack_public_path__ + "img/00034.871dde84.webp";